import React from "react";
import type { AdminNotificationCommunityOption } from "../api/client";

export function CommunitySelect({
  communities,
  value,
  onChange,
  placeholder = "Alle Communities",
  label = "Community",
}: {
  communities: AdminNotificationCommunityOption[];
  value: string;
  onChange: (id: string) => void;
  placeholder?: string;
  label?: string;
}) {
  return (
    <label className="grid gap-1.5 text-sm font-medium text-gray-700">
      {label}
      <select
        className="form-control w-full font-normal"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">{placeholder}</option>
        {value && !communities.some((c) => c.id === value) && (
          <option value={value}>Gewählte Community (nicht verfügbar)</option>
        )}
        {communities.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
    </label>
  );
}
